import {
    EngagementAPIOperator,
    EngagementName,
    EngagementUIOperator,
    Segment,
    SegmentDemographic,
    SegmentEngagement,
    SegmentEvent,
} from 'domains/segments/types';
import { getInclusionOperatorFromAPIToUI } from 'domains/segments/utils';

const engagmentNegativeDescriptions = {
    [EngagementName.CLICKED_SENDS]: EngagementUIOperator.DID_NOT_CLICK,
    [EngagementName.DELIVERED_SENDS]: EngagementUIOperator.DID_NOT_DELIVER,
    [EngagementName.OPENED_SENDS]: EngagementUIOperator.DID_NOT_OPEN,
    [EngagementName.RECEIVED_SENDS]: EngagementUIOperator.DID_NOT_RECEIVE,
    [EngagementName.REPLIED_SENDS]: EngagementUIOperator.DID_NOT_REPLY,
    [EngagementName.CALL_ANSWERED_SENDS]: '',
    [EngagementName.NOT_PICKED_SENDS]: '',
    [EngagementName.VOICEMAIL_SENT_SENDS]: '',
    [EngagementName.CALL_FAILED_SENDS]: '',
    [EngagementName.CALL_TRANSFERED_SENDS]: '',
    [EngagementName.SENT_SENDS]: EngagementUIOperator.NOT_SENT,
};

const engagementDescriptions = {
    [EngagementName.CLICKED_SENDS]: EngagementUIOperator.DID_CLICK,
    [EngagementName.DELIVERED_SENDS]: EngagementUIOperator.DID_DELIVER,
    [EngagementName.OPENED_SENDS]: EngagementUIOperator.DID_OPEN,
    [EngagementName.RECEIVED_SENDS]: EngagementUIOperator.DID_RECEIVE,
    [EngagementName.REPLIED_SENDS]: EngagementUIOperator.DID_REPLY,
    [EngagementName.CALL_ANSWERED_SENDS]: EngagementUIOperator.CALL_ANSWERED,
    [EngagementName.NOT_PICKED_SENDS]: EngagementUIOperator.CALL_NOT_ANSWERED,
    [EngagementName.VOICEMAIL_SENT_SENDS]: EngagementUIOperator.VOICEMAIL,
    [EngagementName.CALL_FAILED_SENDS]: EngagementUIOperator.CALL_FAILED,
    [EngagementName.CALL_TRANSFERED_SENDS]: EngagementUIOperator.CALL_TRANSFERRED,
    [EngagementName.SENT_SENDS]: EngagementUIOperator.SENT,
};

const getEngagementDescription = (engagementSegments: SegmentEngagement[]) =>
    engagementSegments.map((segment) => {
        const isNegativeOperator = segment.operator === EngagementAPIOperator.DOES_NOT_CONTAIN;
        if (isNegativeOperator) return `${engagmentNegativeDescriptions[segment.name]} email`;

        return `${engagementDescriptions[segment.name]} email`;
    });

const getDemographicDescription = (demographicSegments: SegmentDemographic[]) =>
    demographicSegments.map((segment) => {
        const { name, operator, value } = segment;
        const operatorForDisplay = getInclusionOperatorFromAPIToUI(operator);
        const valueForDisplay = Array.isArray(value) ? value.map((string) => ` ${string}`) : value;
        return `${name} ${operatorForDisplay} ${valueForDisplay}`;
    });

const getContactEventDescription = (contactEventSegments: SegmentEvent[]) =>
    contactEventSegments.map((segment) => `contact event: ${segment.selector || 'unknown'}`);

const getContactObjectDescription = (contactObjectSegments: SegmentEvent[]) =>
    contactObjectSegments.map((segment) => `contact object: ${segment.selector || 'unknown'}`);

export const getSplitDescription = (segmentData: Segment): string[] | undefined => {
    // TODO: update this to account for multiple segments of different categories within a single split
    const engagementSegments = segmentData?.segmentDefinition?.engagement;
    if (engagementSegments?.length) return getEngagementDescription(engagementSegments);

    const demographicSegments = segmentData?.segmentDefinition?.demographic;
    if (demographicSegments?.length) return getDemographicDescription(demographicSegments);

    const contactEventSegments = segmentData?.segmentDefinition?.contactEvent;
    if (contactEventSegments?.length) return getContactEventDescription(contactEventSegments);

    const contactObjectSegments = segmentData?.segmentDefinition?.contactObject;
    if (contactObjectSegments?.length) return getContactObjectDescription(contactObjectSegments);
};
